/**
 * Buscador de regalos (sections/mb-buscador-regalos.liquid).
 * Quiz de 3 pasos: ocasión, destinatario y presupuesto. Filtra en el navegador el catálogo que la sección
 * deja en un <script type="application/json"> y muestra/ordena las tarjetas ya renderizadas (<li data-handle>).
 * Estado en la URL: #regalo=ocasion,destinatario,precio
 *   (ocasion "todas", destinatario "yo" | "cualquiera", precio 15 | 25 | mas | any).
 *
 * Resultados: coincidencia exacta primero (orden de ventas); si hay menos de 3, se completan con «cercanos»
 * (misma ocasión o mismo destinatario) bajo «También le puede gustar». Siempre cierra la tarjeta «Crea su tarro».
 * Los enlaces a tarros personalizables y a crea-tu-tarro llevan ?dedicatoria=<frase según destinatario> y &ocasion=<clave> (selector de la ficha).
 */
(() => {
  if (customElements.get('buscador-regalos')) return;

  // Etiqueta visible por clave de etiqueta de Shopify. El orden de este objeto es el orden de los chips.
  const OCASIONES = {
    cumpleanos: 'Cumpleaños',
    boda: 'Boda',
    comunion: 'Comunión',
    bautizo: 'Bautizo',
    san_valentin: 'San Valentín',
    aniversario: 'Aniversario',
    dia_madre: 'Día de la madre',
    dia_padre: 'Día del padre',
    baby_shower: 'Baby shower',
    despedida_soltera: 'Despedida de soltera',
    fin_curso: 'Fin de curso',
    graduacion: 'Graduación',
    jubilacion: 'Jubilación',
    halloween: 'Halloween',
    navidad: 'Navidad',
    amigo_invisible: 'Amigo invisible',
    empresa: 'Empresa',
  };

  // Complemento de «Regalos …» en el encabezado de resultados
  const OCASIONES_FRASE = {
    cumpleanos: 'de cumpleaños',
    boda: 'de boda',
    comunion: 'de comunión',
    bautizo: 'de bautizo',
    san_valentin: 'de San Valentín',
    aniversario: 'de aniversario',
    dia_madre: 'para el día de la madre',
    dia_padre: 'para el día del padre',
    baby_shower: 'de baby shower',
    despedida_soltera: 'para una despedida de soltera',
    fin_curso: 'de fin de curso',
    graduacion: 'de graduación',
    jubilacion: 'de jubilación',
    halloween: 'de Halloween',
    navidad: 'de Navidad',
    amigo_invisible: 'de amigo invisible',
    empresa: 'para empresa',
  };

  const DESTINATARIOS = {
    amiga: 'Una amiga',
    amigo: 'Un amigo',
    madre: 'Mamá',
    padre: 'Papá',
    novia: 'Mi novia',
    novio: 'Mi novio',
    hija: 'Mi hija',
    hijo: 'Mi hijo',
    profesora: 'Profesora',
    empleado: 'Un empleado',
    cliente_corporativo: 'Un cliente',
  };

  // Tras «para» en el encabezado de resultados
  const DESTINATARIOS_FRASE = {
    amiga: 'tu amiga',
    amigo: 'tu amigo',
    madre: 'tu madre',
    padre: 'tu padre',
    novia: 'tu novia',
    novio: 'tu novio',
    hija: 'tu hija',
    hijo: 'tu hijo',
    profesora: 'tu profesora',
    empleado: 'tu empleado',
    cliente_corporativo: 'tu cliente',
    yo: 'ti',
  };

  // Frase sugerida para el vinilo del tarro (Dedicatoria, máx. 40 caracteres)
  const LARGO_DEDICATORIA = 40;
  const DEDICATORIAS = {
    profesora: 'Gracias por este curso tan dulce',
    madre: 'Para la mejor mamá del mundo',
    amiga: 'Para mi persona favorita',
    novia: 'Eres lo más dulce de mi vida',
    novio: 'Eres lo más dulce de mi vida',
    hija: 'Para mi pequeña gran campeona',
    hijo: 'Para mi pequeño gran campeón',
    padre: 'Para el mejor papá',
    empleado: 'Gracias por tu gran trabajo',
    amigo: 'Para un amigo de los buenos',
  };

  // Rangos sobre price_min (en céntimos): hasta 15 € | más de 15 y hasta 25 € | más de 25 € | cualquiera
  const PRECIOS = {
    15: { texto: 'Hasta 15 €', frase: 'hasta 15 €', min: -1, max: 1500 },
    25: { texto: '15–25 €', frase: 'entre 15 y 25 €', min: 1500, max: 2500 },
    mas: { texto: 'Más de 25 €', frase: 'de más de 25 €', min: 2500, max: Infinity },
    any: { texto: 'Me da igual', frase: '', min: -1, max: Infinity },
  };

  const MAX_RESULTADOS = 6;
  const MINIMO_DESEADO = 3;
  const CLAVES = { ocasion: 'o', destinatario: 'd', precio: 'p' };

  const humanizar = (clave) => {
    const t = clave.replace(/_/g, ' ');
    return t.charAt(0).toUpperCase() + t.slice(1);
  };

  /** Ocasión del buscador -> clave del selector de la ficha del tarro (?ocasion=). Sin entrada = no se envía. */
  const OCASION_FICHA = {
    cumpleanos: 'cumpleanos',
    comunion: 'comunion',
    boda: 'boda',
    bautizo: 'bautizo',
    baby_shower: 'bautizo',
    san_valentin: 'san_valentin',
    aniversario: 'san_valentin',
    dia_madre: 'dia_madre',
    dia_padre: 'dia_padre',
    navidad: 'navidad',
    amigo_invisible: 'amigo_invisible',
    fin_curso: 'fin_curso',
    jubilacion: 'jubilacion',
    despedida_soltera: 'despedida_soltera',
  };

  /** Devuelve `href` con ?dedicatoria=<frase> y &ocasion=<clave> (los que haya), conservando el resto de parámetros. */
  const conDedicatoria = (href, frase, ocasion) => {
    try {
      const u = new URL(href, window.location.origin);
      u.searchParams.delete('dedicatoria');
      u.searchParams.delete('ocasion');
      const resto = u.searchParams.toString();
      const extra = frase ? `dedicatoria=${encodeURIComponent(frase)}` : '';
      const clave = ocasion ? `ocasion=${encodeURIComponent(ocasion)}` : '';
      const query = [resto, extra, clave].filter(Boolean).join('&');
      return u.pathname + (query ? `?${query}` : '') + u.hash;
    } catch (e) {
      return href;
    }
  };

  class BuscadorRegalos extends HTMLElement {
    connectedCallback() {
      if (this.iniciado) return;
      this.iniciado = true;

      const leer = (selector, defecto) => {
        const nodo = this.querySelector(selector);
        try {
          return JSON.parse(nodo ? nodo.textContent : '') || defecto;
        } catch (e) {
          return defecto;
        }
      };
      this.catalogo = leer('script[data-catalogo]', []);
      this.colecciones = leer('script[data-colecciones]', {});
      if (!this.catalogo.length) return;

      this.pasos = [...this.querySelectorAll('[data-paso]')];
      this.progreso = this.querySelector('[data-progreso]');
      this.pasoNum = this.querySelector('[data-paso-num]');
      this.acciones = this.querySelector('[data-acciones]');
      this.resultado = this.querySelector('[data-resultado]');
      this.titulo = this.querySelector('[data-resultado-titulo]');
      this.lista = this.querySelector('[data-lista]');
      this.crea = this.querySelector('[data-crea]');
      this.contador = this.querySelector('[data-contador]');
      this.nota = this.querySelector('[data-nota]');
      this.idea = this.querySelector('[data-idea]');
      this.subtitulo = this.querySelector('[data-subtitulo]');
      this.todos = this.querySelector('[data-todos]');
      this.tarjetas = new Map(
        [...this.querySelectorAll('[data-handle]')].map((li) => [li.dataset.handle, li])
      );
      this.enviados = new Set();

      this.construirChips();

      this.addEventListener('click', (e) => this.alClic(e));
      window.addEventListener('popstate', () => this.pintar(false));
      window.addEventListener('hashchange', () => this.pintar(false));

      const venia = /^#regalo=/.test(location.hash);
      this.pintar(false);
      if (venia && this.estado().p) {
        requestAnimationFrame(() => this.closest('#buscador-regalos')?.scrollIntoView({ block: 'start' }));
      }
    }

    // ---- Chips: solo opciones con al menos un producto activo en el catálogo ----
    construirChips() {
      const existentes = (prefijo) => {
        const set = new Set();
        this.catalogo.forEach((p) =>
          p.g.forEach((t) => t.startsWith(prefijo) && set.add(t.slice(prefijo.length)))
        );
        return set;
      };
      const ordenar = (set, mapa) => [
        ...Object.keys(mapa).filter((k) => set.has(k)),
        ...[...set].filter((k) => !(k in mapa)).sort(),
      ];

      const ocasiones = existentes('ocasion_');
      const destinatarios = existentes('destinatario_');
      this.validas = { o: new Set(['todas', ...ocasiones]), d: new Set(['yo', 'cualquiera', ...destinatarios]) };

      const llenar = (tipo, items) => {
        const caja = this.querySelector(`[data-chips="${tipo}"]`);
        caja.append(
          ...items.map(([valor, texto]) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'mb-regalos__chip';
            b.dataset.tipo = tipo;
            b.dataset.valor = valor;
            b.textContent = texto;
            return b;
          })
        );
      };

      llenar('ocasion', [
        ...ordenar(ocasiones, OCASIONES).map((k) => [k, OCASIONES[k] || humanizar(k)]),
        ['todas', 'Sin ocasión, solo porque sí'],
      ]);
      llenar('destinatario', [
        ...ordenar(destinatarios, DESTINATARIOS).map((k) => [k, DESTINATARIOS[k] || humanizar(k)]),
        ['yo', 'Para mí'],
        ['cualquiera', 'Me da igual'],
      ]);
      llenar(
        'precio',
        Object.entries(PRECIOS).map(([k, v]) => [k, v.texto])
      );
    }

    // ---- Estado en la URL ----
    estado() {
      const m = location.hash.match(/^#regalo=([^&]*)/);
      let partes = [];
      try {
        partes = m ? decodeURIComponent(m[1]).split(',') : [];
      } catch (e) {
        partes = [];
      }
      const [o, d, p] = partes;
      const est = {};
      if (this.validas.o.has(o)) {
        est.o = o;
        if (this.validas.d.has(d)) {
          est.d = d;
          if (Object.prototype.hasOwnProperty.call(PRECIOS, p)) est.p = p;
        }
      }
      return est;
    }

    ir(est, moverFoco = true) {
      const partes = [est.o, est.d, est.p].filter(Boolean);
      const url = location.pathname + location.search + (partes.length ? `#regalo=${partes.join(',')}` : '');
      history.pushState(null, '', url);
      this.pintar(moverFoco);
    }

    alClic(e) {
      const chip = e.target.closest('.mb-regalos__chip');
      if (chip) {
        const est = this.estado();
        est[CLAVES[chip.dataset.tipo]] = chip.dataset.valor;
        this.ir(est);
        return;
      }
      if (e.target.closest('[data-atras]')) {
        const est = this.estado();
        if (est.p) delete est.p;
        else if (est.d) delete est.d;
        else delete est.o;
        this.ir(est);
        return;
      }
      if (e.target.closest('[data-reiniciar]')) this.ir({});
    }

    // ---- Pintado ----
    pintar(moverFoco) {
      const est = this.estado();
      const paso = !est.o ? 1 : !est.d ? 2 : !est.p ? 3 : 4;

      this.pasos.forEach((f) => (f.hidden = Number(f.dataset.paso) !== paso));
      this.querySelectorAll('.mb-regalos__chip').forEach((b) => {
        b.setAttribute('aria-pressed', est[CLAVES[b.dataset.tipo]] === b.dataset.valor ? 'true' : 'false');
      });

      const enPasos = paso < 4;
      this.progreso.hidden = !enPasos;
      this.acciones.hidden = !(enPasos && paso > 1);
      this.resultado.hidden = enPasos;

      if (enPasos) {
        this.pasoNum.textContent = `${paso}/3`;
        this.pasoNum.setAttribute('aria-label', `Paso ${paso} de 3`);
        this.style.setProperty('--mb-regalos-avance', `${(paso / 3) * 100}%`);
        if (moverFoco) this.pasos[paso - 1].querySelector('legend').focus({ preventScroll: true });
      } else {
        this.mostrarResultados(est);
        if (moverFoco) this.llevarAResultados();
      }
    }

    /** Foco en el encabezado de resultados y desplazamiento suave (instantáneo con movimiento reducido). */
    llevarAResultados() {
      this.titulo.focus({ preventScroll: true });
      const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.resultado.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'start' });
    }

    /** «Regalos de cumpleaños para tu amiga, hasta 25 €» */
    encabezado(est) {
      let texto = 'Regalos';
      if (est.o !== 'todas') {
        const frase = OCASIONES_FRASE[est.o] || `de ${(OCASIONES[est.o] || humanizar(est.o)).toLowerCase()}`;
        texto += ` ${frase}`;
      }
      if (est.d !== 'cualquiera') {
        const para = `para ${DESTINATARIOS_FRASE[est.d] || 'ti'}`;
        texto += texto.includes(' para ') ? `, ${para}` : ` ${para}`;
      }
      const precio = PRECIOS[est.p].frase;
      if (precio) texto += texto === 'Regalos' ? ` ${precio}` : `, ${precio}`;
      return texto;
    }

    mostrarResultados(est) {
      const o = est.o === 'todas' ? null : est.o;
      const d = est.d === 'yo' || est.d === 'cualquiera' ? null : est.d;
      const rango = PRECIOS[est.p];

      const evaluados = this.catalogo.map((prod) => {
        const oc = o ? prod.g.includes(`ocasion_${o}`) : false;
        const de = d ? prod.g.includes(`destinatario_${d}`) : false;
        const pr = prod.p > rango.min && prod.p <= rango.max;
        const exacto = (!o || oc) && (!d || de) && pr;
        // Cercano: misma ocasión o mismo destinatario (cuando se han elegido), aunque cambie el resto
        const puntos = (oc ? 4 : 0) + (de ? 2 : 0) + (pr ? 1 : 0);
        return { prod, exacto, cercano: !exacto && (oc || de), puntos };
      });

      const porVentas = (a, b) => a.prod.r - b.prod.r;
      const exactos = evaluados.filter((x) => x.exacto).sort(porVentas).slice(0, MAX_RESULTADOS);
      let cercanos = [];
      if (exactos.length < MINIMO_DESEADO) {
        cercanos = evaluados
          .filter((x) => x.cercano)
          .sort((a, b) => b.puntos - a.puntos || porVentas(a, b))
          .slice(0, MAX_RESULTADOS - exactos.length);
        // Sin nada parecido: los más vendidos, para no dejar al cliente sin opciones
        if (!exactos.length && !cercanos.length) {
          cercanos = evaluados.filter((x) => !x.exacto).sort(porVentas).slice(0, MAX_RESULTADOS);
        }
      }

      // Dedicatoria sugerida según destinatario; los enlaces a tarros personalizables la llevan en la URL
      const dedicatoria = (d ? DEDICATORIAS[d] || '' : '').slice(0, LARGO_DEDICATORIA);
      const ocasionFicha = (o && OCASION_FICHA[o]) || '';

      // Mostrar y ordenar: exactos, subtítulo, cercanos, tarjeta «Crea su tarro»
      const visibles = new Set();
      const poner = ({ prod }) => {
        const li = this.tarjetas.get(prod.h);
        if (!li) return false;
        li.hidden = false;
        visibles.add(li);
        this.lista.append(li);
        if (prod.g.includes('tipo_tarro')) this.ponerDedicatoria(li, dedicatoria, ocasionFicha);
        return true;
      };
      const nExactos = exactos.filter(poner).length;
      if (cercanos.length) {
        this.subtitulo.querySelector('[data-subtitulo-texto]').textContent = nExactos
          ? 'También le puede gustar'
          : 'Lo que más se acerca';
        this.lista.append(this.subtitulo);
      }
      const nCercanos = cercanos.filter(poner).length;
      this.subtitulo.hidden = nCercanos === 0;
      this.tarjetas.forEach((li) => {
        if (!visibles.has(li)) li.hidden = true;
      });
      this.lista.append(this.crea);

      this.pintarCrea(est, dedicatoria, ocasionFicha);
      this.pintarIdea(dedicatoria);
      this.pintarTodos(est);

      this.titulo.textContent = this.encabezado(est);
      const n = visibles.size;
      this.nota.textContent =
        nExactos === 0
          ? 'No tenemos un regalo exacto para esa combinación. Mira lo que más se acerca o crea su tarro con su nombre.'
          : nExactos < MINIMO_DESEADO && nCercanos
            ? 'Tenemos pocos regalos exactos para esa combinación, te enseñamos también otros parecidos.'
            : '';
      this.nota.hidden = !this.nota.textContent;

      // Borrar y volver a escribir para que el lector de pantalla lo anuncie siempre.
      this.contador.textContent = '';
      requestAnimationFrame(() => {
        this.contador.textContent = n === 1 ? '1 regalo para ti.' : `${n} regalos para ti.`;
      });

      this.medir(est, n);
    }

    /** Añade (o quita) ?dedicatoria= y ?ocasion= en los enlaces de producto de una tarjeta. */
    ponerDedicatoria(li, frase, ocasion) {
      li.querySelectorAll('a[href*="/products/"]').forEach((a) => {
        if (!a.dataset.hrefOriginal) a.dataset.hrefOriginal = a.getAttribute('href');
        a.setAttribute('href', conDedicatoria(a.dataset.hrefOriginal, frase, ocasion));
      });
    }

    pintarCrea(est, dedicatoria, ocasion) {
      const enlace = this.crea.querySelector('[data-crea-enlace]');
      if (enlace) {
        if (!enlace.dataset.hrefOriginal) enlace.dataset.hrefOriginal = enlace.getAttribute('href');
        enlace.setAttribute('href', conDedicatoria(enlace.dataset.hrefOriginal, dedicatoria, ocasion));
      }
      const paraMi = est.d === 'yo';
      const titulo = this.crea.querySelector('[data-crea-titulo]');
      const texto = this.crea.querySelector('[data-crea-texto]');
      const boton = this.crea.querySelector('[data-crea-enlace]');
      if (titulo) titulo.textContent = paraMi ? 'Crea tu tarro con tu nombre' : 'Crea su tarro con su nombre';
      if (boton) boton.textContent = paraMi ? 'Crear mi tarro' : 'Crear su tarro';
      if (texto) {
        texto.textContent = dedicatoria
          ? `Elige las chuches y escribe su nombre en la pegatina. Ya te proponemos la dedicatoria: «${dedicatoria}».`
          : paraMi
            ? 'Elige las chuches y escribe tu nombre en la pegatina.'
            : 'Elige las chuches y escribe su nombre en la pegatina.';
      }
    }

    pintarIdea(dedicatoria) {
      if (!this.idea) return;
      this.idea.hidden = !dedicatoria;
      const frase = this.idea.querySelector('[data-idea-frase]');
      if (frase) frase.textContent = dedicatoria;
    }

    /** «Ver todos los regalos de cumpleaños» -> colección de esa ocasión si existe; si no, todos los tarros. */
    pintarTodos(est) {
      if (!this.todos) return;
      const url = est.o !== 'todas' ? this.colecciones[est.o] : '';
      if (url) {
        const frase = OCASIONES_FRASE[est.o] || `de ${(OCASIONES[est.o] || humanizar(est.o)).toLowerCase()}`;
        this.todos.setAttribute('href', url);
        this.todos.textContent = `Ver todos los regalos ${frase}`;
      } else {
        this.todos.setAttribute('href', this.todos.dataset.destinoDefecto || this.todos.getAttribute('href'));
        this.todos.textContent = 'Ver todos los tarros';
      }
    }

    /** dataLayer: una vez por combinación mostrada. */
    medir(est, resultados) {
      const clave = `${est.o}|${est.d}|${est.p}`;
      if (this.enviados.has(clave)) return;
      this.enviados.add(clave);
      const carga = { ocasion: est.o, destinatario: est.d, presupuesto: est.p, resultados };
      try {
        if (window.mbDataLayer && typeof window.mbDataLayer.push === 'function') {
          window.mbDataLayer.push('buscador_regalos', carga);
        } else {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'buscador_regalos', ...carga });
        }
      } catch (e) {
        /* la medición nunca debe romper el buscador */
      }
    }
  }

  customElements.define('buscador-regalos', BuscadorRegalos);
})();
